import './App.css';
import Footer from './components/Layout/Footer'
import Header from './components/Layout/Header';
import Accordion from './components/Accordion';
import FarBafForm from './components/FarBafForm';
import Authenticator from './components/Authenticator';
import Explication from './components/Explication';
import Card from './components/Layout/Card';
import './style/AccessibilityEnhancement.css'



function App() {
  return (
    <div className="App">
      <Header/>
      <div className="App-section">
          <div className='submitForm'>
            <Authenticator/>
            <Card title="Explication">
                <Explication/>
            </Card>
            <FarBafForm/>
          </div>
      </div>
      <Footer/>
    </div>
  );
}

export default App;
